export const notificationTypeEnum =
{
    none: 0,
    email: 1,
    sms: 3
}